var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransporte2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90.2 87.3",
    style: {
      enableBackground: "new 0 0 90.2 87.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transporte",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000082336563939218631700000014525261705121154484_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    className: "st0",
    d: "M23.6,76.1v4.5c-0.1,4.1-2.6,6.7-6.6,6.7s-6.4-2.5-6.5-6.5c0-1.5,0-3,0-4.5 c-3.2-0.7-3.2-0.7-3.2-4V52H2.4c-1.1,0.2-2.2-0.6-2.4-1.8c0-0.2,0-0.4,0-0.6c0-5,0-10.1,0-15.1c0-1.6,0.8-2.3,2.4-2.3s3.1,0,4.9,0 V9.9C7.3,3.7,11,0,17.3,0h55.6c6.3,0,10,3.7,10,9.9v22.2h4.5c2.2,0,2.7,0.6,2.7,2.7v14.6c0,1.9-0.6,2.5-2.5,2.6c-1.5,0-3,0-4.8,0 v20.8c0,2.7-0.2,3-3.2,3.4v4.4c-0.1,4.2-2.5,6.7-6.5,6.7s-6.5-2.5-6.6-6.7c0-1.5,0-2.9,0-4.5L23.6,76.1z M79.2,21.8H11v26.5h17.6 c-3.5-1.4-7.1-2.5-10.6-3.7c-1.2-0.4-2.3-1-1.8-2.5c0.5-1.5,1.7-1.3,2.9-0.9c3.6,1.2,7.3,2.1,10.9,3.5c7.4,3.1,15.5,4.3,23.5,3.7 c1.7-0.1,3.4,0,5.1,0c-0.2-0.3-0.4-0.5-0.8-0.6c-3.3-1.1-6.7-2.1-10-3.2c-1.6-0.5-2.2-1.8-1.5-2.9s1.8-0.8,2.9-0.5 c6.7,2.2,13.3,4.5,20.1,6.4c3.1,0.8,6.5,0.8,9.9,1.2L79.2,21.8z M11,72.2h68.2v-20H11V72.2z M79.3,17.9v-7.8 c0-4.6-1.9-6.5-6.5-6.5H24.1c-2.8,0-5.5-0.1-8.3,0.1c-2.5,0-4.6,1.9-4.9,4.3C10.8,11.3,11,14.6,11,18L79.3,17.9z M3.7,35.9v12.4 h3.4V35.9H3.7z M83.1,35.9v12.4h3.3V35.9L83.1,35.9z M14.1,76c0,1.9-0.1,3.6,0,5.3c0.1,1.6,1.1,2.2,2.6,2.3c1.8,0.1,3-0.6,3.1-2.1 c0.2-1.8,0-3.6,0-5.5L14.1,76z M76.1,76.1h-5.8c0,1.8-0.1,3.5,0,5.2s1.2,2.4,3.1,2.3c1.6-0.1,2.6-0.8,2.6-2.4S76.1,77.9,76.1,76.1 L76.1,76.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    className: "st0",
    d: "M29.1,28.4H17.3c-0.6,0.1-1.3,0-1.9-0.3c-0.5-0.3-0.9-0.8-1-1.4c0.1-0.7,0.4-1.3,1-1.7 c0.6-0.3,1.2-0.4,1.9-0.3h24.4c1.1,0.1,2,0.5,2,1.8c0,1.2-0.8,1.7-1.9,1.8c-1,0.1-2,0-3,0L29.1,28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    className: "st0",
    d: "M50.8,28.3c-2.4,0.1-3.4-0.5-3.3-1.9c0.2-2,1.9-1.7,3.2-1.7c0.6,0,1.3-0.2,1.7,0.1 c0.7,0.4,1.5,1.1,1.6,1.8c0.1,0.5-0.9,1.2-1.6,1.6C52.1,28.5,51.4,28.3,50.8,28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    className: "st0",
    d: "M21.1,68c-3.2,0-5.8-2.5-5.8-5.7c0-3.2,2.5-5.8,5.7-5.8c3.2,0,5.8,2.5,5.8,5.7c0,0,0,0.1,0,0.1 c0,3.1-2.5,5.6-5.6,5.7C21.2,68,21.2,68,21.1,68z M21.5,60h-0.8c-0.6,0.7-1.2,1.5-1.5,2.3c-0.3,1.1,1,2.1,2.1,2 c1.2-0.1,2.1-0.9,1.8-2.1C23,61.5,22.1,60.8,21.5,60L21.5,60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    className: "st0",
    d: "M68.9,68c-3.1,0-5.6-2.6-5.5-5.7c0-3.1,2.5-5.6,5.7-5.6s5.6,2.5,5.6,5.7c0,3.1-2.5,5.6-5.7,5.6 C69,68,68.9,68,68.9,68z M68.6,64.7l0.8,0c0.5-0.8,1.4-1.5,1.5-2.3c0.2-1.2-0.7-1.9-1.9-2c-1.1-0.1-2.3,1.1-2,2.1 C67.4,63.3,68,64,68.6,64.7L68.6,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    className: "st0",
    d: "M45.1,15.8H25.6c-2.4,0-2.9-0.5-2.9-2.9V8.2c0-1.6,0.7-2.4,2.3-2.4h40.3c1.6,0,2.4,0.7,2.3,2.4 c0,1.8,0,3.5,0,5.3s-0.6,2.4-2.5,2.4L45.1,15.8L45.1,15.8z M26.4,12.1h37.5V9.5H26.4V12.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporte2);
export default __webpack_public_path__ + "static/media/Transporte2.83a7c107a4f0c717b3c6531f1f7787ed.svg";
export { ForwardRef as ReactComponent };